import { FlightShopStep, MulticityFlightShopStep } from "../../../shop/reducer";

// A multicity retry must reset to the first leg via `multicityFlightShopProgress` —
// `flightShopProgress` is meaningless to the multicity URL builder, so leaving it set to
// `BookTrip` (checkout's stamped value) would resume the shop at the wrong step.
export const getRedirectToShopQueryParams = (isMulticity: boolean) =>
  isMulticity
    ? { multicityFlightShopProgress: MulticityFlightShopStep.ChooseDeparture0 }
    : { flightShopProgress: FlightShopStep.ChooseDeparture };
